<template>
	<div>
		<NavigationMenuLink v-for="navOption in navOptions" :key="navOption.route">
			<NuxtLink
				class="flex size-full cursor-pointer select-none flex-col justify-end rounded-md bg-gradient-to-b from-muted/50 to-muted p-4 no-underline outline-none transition-all hover:bg-primary-light-4 focus:shadow-md"
				:to="navOption.route"
				@click="handleClick(navOption)"
			>
				<PortalHeaderNavOption
					:variant="navOption.description ? 'description' : 'default'"
				>
					<template #icon>
						<component
							:is="navOption.icon?.component"
							v-if="navOption.icon"
							v-bind="navOption.icon.bindings"
						/>
					</template>
					<template #title>
						{{ navOption.label }}
					</template>
					<template #description>
						{{ navOption.description }}
					</template>
				</PortalHeaderNavOption>
			</NuxtLink>
		</NavigationMenuLink>
	</div>
</template>
<script setup lang="ts">
import { handleEventProps } from '~/composables/events/headerEvents';
import { type NavDefaultOptionConfig } from '.';
import { useEvents } from '~/composables/events/useEvents';
const { trackHeader } = useEvents();

type Props = {
	navOptions: NavDefaultOptionConfig[];
};

defineProps<Props>();

const handleClick = (navOption: NavDefaultOptionConfig) =>
	handleEventProps(
		navOption.eventProps,
		trackHeader.handleEventMenuHeaderClick
	);
</script>
